import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpSecureClient } from '../../../shared/services/http/httpSecureClient';
import { AuthGuardService } from '../../../shared/services/authentication/auth-guard.service';
import { api } from '../../../shared/configuration/urls';
import { config } from 'path-shared/configuration/config';
import { TiquetsFilter } from '../models/tiquets-filter';
import { TiquetsFilterService } from './tiquets-filter.service';
import { HttpParams } from '@angular/common/http';

const defaultSortParam = 'id';
const defaultSortDirection = 'desc';

@Injectable()
export class TiquetsService {
  constructor(
    private http: HttpSecureClient,
    private authGuard: AuthGuardService
  ) {}

  getTiquetsLeyenda(filter: TiquetsFilter): Observable<any> {
    if (this.authGuard.canActivate()) {
      const start = 0;
      const pageSize = 1000;
      const params = new TiquetsFilterService().createFilterParams(filter, start, pageSize, defaultSortParam, defaultSortDirection);

      const url = config.urls['apiUrl'] + api.endpoints['urlGetTiquetsLeyenda'];
      return this.http.get(url, params);
    }
  }
  getProveidors():Observable<any>{
    if (this.authGuard.canActivate()) {

      const url = config.urls['apiUrl'] + api.endpoints['urlGetProveidorsTiquets'];
      return this.http.get(url, null);
    }
  }
  generateExcel(filter: TiquetsFilter, sortDir: string, sortField: string): Observable<any> {
    const start = 0;
    const pageSize = 1000;

    sortField = sortField === undefined ? defaultSortParam : sortField;
    sortDir = sortDir === '' ? defaultSortDirection : sortDir;
    const params = new TiquetsFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);



    if (this.authGuard.canActivate()) {
      return this.http.getFileResponse(config.urls['apiUrl'] + api.endpoints['urlTiquetsExcel'],  params );
      //return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlTiquetsExcel'],  params );
    }
  }
}
